import {useState} from "react";
import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {UnitSystem} from "../../../../../api/Projects";
import {parseDimension} from "../components/DimensionEditor";

// A small modal that requests a single dimension, used by the "Door Cuts" ribbon
// group to add an overcut / undercut. The field accepts the project's unit system
// (imperial like `1 1/2"` or metric like `38 mm`); an empty/invalid entry, or one
// that isn't a positive length, keeps the dialog open.
export function CutDimensionDialog(props: {
    open: boolean;
    title: string;
    sys: UnitSystem;
    onClose: () => void;
    onSubmit: (value: number) => void;
}) {
    const [value, setValue] = useState("");

    if(!props.open) return null;

    const parsed = parseDimension(value, props.sys);
    const valid = !isNaN(parsed) && parsed > 0;

    const submit = () => {
        if(!valid) return;
        props.onSubmit(parsed);
        setValue("");
    };

    const close = () => {
        setValue("");
        props.onClose();
    };

    return (
        <Dialog2 open onClose={close} maxWidth="xs" fullWidth>
            {/* a form so Enter submits (implicit submission) rather than falling
                through to the dialog. Cancel is type="button" so it's never the
                implicit submit target. */}
            <form onSubmit={e => { e.preventDefault(); submit(); }}>
                <DialogTitle>{props.title}</DialogTitle>
                <DialogContent>
                    <TextField
                        label={props.sys === "metric" ? "Dimension (mm)" : "Dimension"}
                        value={value}
                        onChange={e => setValue(e.currentTarget.value)}
                        onFocus={e => e.currentTarget.select()}
                        autoFocus
                        fullWidth
                        margin="dense"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={close}>Cancel</Button>
                    <Button type="submit" disabled={!valid} variant="contained">Add</Button>
                </DialogActions>
            </form>
        </Dialog2>
    );
}
